var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 66,
    viewBox: "0 0 71 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H29.5",
    stroke: "#0079E6",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5H18.8125",
    stroke: "#0079E6",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9H18.8125",
    stroke: "#0079E6",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13H18.8125",
    stroke: "#0079E6",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17H29.5",
    stroke: "#0079E6",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21H18.8125",
    stroke: "#0079E6",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 25H18.8125",
    stroke: "#0079E6",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 29H18.8125",
    stroke: "#0079E6",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 33H29.5",
    stroke: "#0079E6",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1 37H18.8125",
    stroke: "#0079E6",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1 41H18.8125",
    stroke: "#0079E6",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1 45H18.8125",
    stroke: "#0079E6",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1 49H29.5",
    stroke: "#0079E6",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1 53H18.8125",
    stroke: "#0079E6",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1 57H18.8125",
    stroke: "#0079E6",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1 61H18.8125",
    stroke: "#0079E6",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1 65H29.5",
    stroke: "#0079E6",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4393 54.5607C59.0251 55.1464 59.9749 55.1464 60.5607 54.5607L70.1066 45.0147C70.6924 44.4289 70.6924 43.4792 70.1066 42.8934C69.5208 42.3076 68.5711 42.3076 67.9853 42.8934L59.5 51.3787L51.0147 42.8934C50.4289 42.3076 49.4792 42.3076 48.8934 42.8934C48.3076 43.4792 48.3076 44.4289 48.8934 45.0147L58.4393 54.5607ZM60.5607 11.4393C59.9749 10.8536 59.0251 10.8536 58.4393 11.4393L48.8934 20.9853C48.3076 21.5711 48.3076 22.5208 48.8934 23.1066C49.4792 23.6924 50.4289 23.6924 51.0147 23.1066L59.5 14.6213L67.9853 23.1066C68.5711 23.6924 69.5208 23.6924 70.1066 23.1066C70.6924 22.5208 70.6924 21.5711 70.1066 20.9853L60.5607 11.4393ZM61 53.5L61 12.5L58 12.5L58 53.5L61 53.5Z",
    fill: "#0086FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSize);
export default __webpack_public_path__ + "static/media/size.3a120a6dd4a0ec29066a77adaf1f2583.svg";
export { ForwardRef as ReactComponent };